/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DataCell',
  props: {
    cellTitle: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      cellTitle = _toRefs.cellTitle;
    return function (_ctx, _cache) {
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createBlock(_component_van_cell_group, {
        class: "data-cell",
        inset: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell, {
            title: _unref(cellTitle)
          }, {
            label: _withCtx(function () {
              return [_renderSlot(_ctx.$slots, "data-cell-tabs"), _renderSlot(_ctx.$slots, "default")];
            }),
            _: 3
          }, 8, ["title"])];
        }),
        _: 3
      });
    };
  }
});